<template>
  <div class="new-input-box" v-loading="checkLoading">
    <input-form
      class="mb16"
      :inputData="myformInfo"
      @toParentVal="submitFormFun"
      :btnPosition1="true"
    ></input-form>
    <el-tooltip
      class="item"
      effect="dark"
      content="当前账号没有创建权限，请联系管理员添加。"
      placement="top"
      v-if="!permissions.includes('platform:benefit:create')"
    >
      <el-button disabled type="primary">创建任务</el-button>
    </el-tooltip>
    <el-button type="primary" v-else @click="createTasks">创建任务</el-button>
    <!-- <el-checkbox
      v-model="form.createByMe"
      style="margin-left: 20px"
      @change="handleCreateByMe"
      >我创建的</el-checkbox
    > -->
    <div class="new-table-box" style="margin-top: 12px">
      <el-table
        :data="tableData"
        v-loading="talbeLoading"
        style="width: 100%; border: 1px solid #f0f0f0;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column prop="taskName" label="任务名称" width="200">
        </el-table-column>
        <el-table-column prop="planName" label="红包计划名称" width="200">
        </el-table-column>
        <el-table-column label="权益归属店铺" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.belongShopTitle || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="redPackAmount"
          label="发放红包金额（每份）"
          width="200"
        >
        </el-table-column>
        <el-table-column prop="sendNum" label="预计发放数" width="200">
        </el-table-column>
        <el-table-column prop="successNum" label="实际发放数" width="200">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200">
        </el-table-column>
        <el-table-column label="完成时间" width="200">
          <template slot-scope="scope">
            <span>
              {{
                scope.row.status === 0 || scope.row.status === 1
                  ? "-"
                  : scope.row.finishTime
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="任务状态" width="200">
          <template slot-scope="scope">
            <div>
              <jd-status :status="2" v-if="scope.row.status == 0"
                >待执行</jd-status
              >
              <jd-status :status="1" v-else-if="scope.row.status == 1"
                >执行中</jd-status
              >
              <jd-status :status="4" v-else-if="scope.row.status == 2"
                >执行结束</jd-status
              >
              <jd-status :status="4" v-else>已终止</jd-status>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="任务类型" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.type === 1 ? "定时发送" : "立即发送" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="发送时间" width="200">
          <template slot-scope="scope">
            <div>
              {{ scope.row.sendTime || "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.type === 1 && scope.row.status === 0"
              type="text"
              class="btn-style"
              @click="handleStop(scope.row)"
              >终止</el-button
            >
            <el-button
              class="btn-style"
              type="text"
              @click="checkDetail(scope.row)"
              >查看</el-button
            >
            <el-button
              class="btn-style"
              type="text"
              @click="checkGrant(scope.row)"
              >发放明细</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="pagination-box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="text-align: right"
          :current-page="form.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="form.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="numTotal"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :title="redEnvelopeFromDisable ? '查看任务详情' : '批量发红包'"
      :visible.sync="couponDialogShow"
      width="1056px"
      @close="closeCouponDialog"
    >
      <el-form
        :model="redEnvelopeFrom"
        label-width="125px"
        class="changeFrom"
        ref="redEnvelopeFrom"
        :rules="redEnvelopeFromRules"
        v-loading="lookLoading"
      >
        <el-form-item label="任务名称：" prop="taskName">
          <el-input
            v-model="redEnvelopeFrom.taskName"
            style="width: 508px"
            placeholder="请输入"
            maxlength="30"
            show-word-limit
            :disabled="redEnvelopeFromDisable"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务类型：" prop="type" required>
          <el-radio-group
            :disabled="redEnvelopeFromDisable"
            v-model="redEnvelopeFrom.type"
          >
            <el-radio :label="0">立即发送</el-radio>
            <el-radio :label="1">定时发送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="发送时间："
          prop="sendTime"
          v-if="redEnvelopeFrom.type == 1"
        >
          <div class="my_select_time">
            <el-date-picker
              prefix-icon="no_icon"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择日期时间"
              size="small"
              v-model="redEnvelopeFrom.sendTime"
              :picker-options="pickerOptions2"
              :clearable="false"
              :disabled="redEnvelopeFromDisable"
            >
            </el-date-picker>
            <i
              class="el-icon-circle-close date_icon1"
              @click="clearSendTime"
            ></i>
            <img
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
              alt=""
              class="date_icon2"
            />
          </div>
        </el-form-item>
        <el-form-item label="添加人群：" required>
          <el-radio-group
            :disabled="redEnvelopeFromDisable"
            v-model="redEnvelopeFrom.selectCrowdType"
          >
            <el-radio :label="2">输入pin</el-radio>
            <el-radio :label="3">导入pin</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="redEnvelopeFrom.selectCrowdType == 2">
          <el-form-item label="输入pin：" prop="pinList">
            <el-input
              style="width: 450px"
              type="textarea"
              placeholder="请输入"
              v-model="redEnvelopeFrom.pinList"
              :autosize="{ minRows: 4, maxRows: 6 }"
              :disabled="redEnvelopeFromDisable"
            >
            </el-input>
            <div
              class="form_tip fz14"
              style="margin-top: 10px; line-height: 20px; width: 400px"
            >
              <div style="display: flex; align-items: center">
                <img
                  style="width: 16px; height: 16px"
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_gray.jpg"
                />
                <span>注：1. 支持输入明文pin，每行一个用户pin；</span>
              </div>
              <div style="margin-left: 40px; margin-top: 5px">
                2.手动输入，一次输入最多支持2000行
              </div>
            </div>
          </el-form-item>
        </template>
        <template v-if="redEnvelopeFrom.selectCrowdType == 3">
          <el-form-item label="选择文件：" class="upload_item" prop="fileUrl">
            <el-upload
              v-if="!redEnvelopeFromDisable"
              ref="uploadFile"
              class="upload_box"
              :on-remove="removeFile"
              :file-list="fileList"
              action="#"
              :multiple="false"
              :limit="2"
              :show-file-list="true"
              :before-upload="beforeUpload"
              :http-request="httpUpload"
            >
              <el-button
                type="primary"
                :isZoom="true"
                zName="上传文件"
                label="上传文件"
                size="small"
              >
                点击上传文件
              </el-button>
            </el-upload>
            <div
              style="position: absolute; top: 0; left: 150px"
              v-if="!redEnvelopeFromDisable"
            >
              <div>
                <i class="el-icon-loading" v-if="!uploadStatus"></i>
                <i
                  class="el-icon-success"
                  style="color: green"
                  v-if="uploadStatus === 1"
                ></i>
                <i
                  class="el-icon-error"
                  style="color: red"
                  v-if="uploadStatus === 2"
                ></i>
                <span v-if="!uploadStatus">上传中</span>
                <span v-if="uploadStatus === 1">上传成功</span>
                <span v-if="uploadStatus === 2">上传失败</span>
              </div>
            </div>
            <el-input
              v-model="redEnvelopeFrom.fileUrl"
              style="display: none"
            ></el-input>
            <div v-if="redEnvelopeFromDisable">
              {{ redEnvelopeFrom.fileName }}
            </div>
          </el-form-item>
          <div
            class="form_tip"
            style="margin: 10px 0 25px 120px; width: 365px; line-height: 20px"
          >
            <div style="display: flex; align-items: center">
              <img
                style="width: 16px; height: 16px"
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip_gray.jpg"
              />
              <span
                >注：1. 下载模板后编辑: 支持输入明文pin；
                <a
                  v-if="redEnvelopeFrom.selectCrowdType == 3"
                  target="_blank"
                  style="color: #7b61ff"
                  href="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E5%AF%BC%E5%85%A5%E6%89%B9%E9%87%8F%E5%8F%91%E6%94%BE%E6%A8%A1%E6%9D%BF.xlsx"
                  >点击下载模板</a
                >
              </span>
            </div>
            <div style="margin-left: 40px; margin-top: 10px">
              2. 支持csv、xls、xlsx格式上传，大小限制在50M内。
            </div>
          </div>
        </template>
        <el-form-item
          label="选择红包计划："
          v-if="!redEnvelopeFromDisable"
          required
        >
          <el-select
            v-model="redEnvelopeFrom.label"
            placeholder="请选择"
            @change="planChange"
            style="width: 215px"
            prop="label"
          >
            <el-option
              v-for="(item, index) in selectList"
              :key="index"
              :label="item.label"
              :value="item"
            ></el-option>
          </el-select>
          <el-button @click="getRedPacketList" type="text" class="btn-style ml8"
            >刷新</el-button
          >
          <el-button @click="jumpJingduo" class="btn-style ml8" type="text"
            >创建红包计划</el-button
          >
          <div v-show="jingdouItem.budgetRemain + ''" style="font-size: 12px;">
            <span>计划剩余</span>
            <span style="color: #fe4d45"> {{ jingdouItem.budgetRemain }} </span
            >份红包
          </div>
        </el-form-item>
        <el-form-item label="红包计划名称：" v-if="redEnvelopeFromDisable">
          {{ redEnvelopeFrom.planName }}
        </el-form-item>
        <el-form-item label="发放红包金额：">
          <el-input
            @input.native="checkputn"
            :disabled="true"
            v-model="redEnvelopeFrom.redPackAmount"
            style="width: 215px"
          ></el-input>
          <span style="margin-left: 8px;font-size: 12px;"
            >元 （每人每次发送的红包金额）</span
          >
        </el-form-item>
        <el-form-item label="权益归属店铺：" v-if="redEnvelopeFromDisable">
          {{ redEnvelopeFrom.shopTitle }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="!redEnvelopeFromDisable">
        <el-button type="primary" @click="batchCouponSure">确认</el-button>
        <el-button @click="closeCouponDialog">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="发放明细"
      :visible.sync="detailDialogShow"
      width="900px"
      @close="closeIntegralDialog"
    >
      <div class="detail_tip" v-loading="detailLoading">
        <div style="font-size: 18px; margin-bottom: 28px">红包发放信息</div>
        <div class="detail-content">
          <div class="content-item">红包计划：{{ grant.planName }}</div>
          <div class="content-item">权益归属店铺：{{ grant.shopTitle }}</div>
          <div class="content-item">
            计划红包总份数：{{ grant.quantityTotal }}
          </div>
          <!-- <div>已发放红包份数：{{ grant.budgetRemain }}</div> -->
          <div class="content-item">
            发放红包金额：{{ grant.redPackAmount }}元
          </div>
          <div class="content-item">已发放人数：{{ grant.successNum }}</div>
        </div>
      </div>
      <input-form
        class="mb16"
        :inputData="detailFromInfo"
        @toParentVal="distributionBeansSure"
        :btnPosition1="true"
      ></input-form>
      <el-table
        :data="detailtableData"
        v-loading="detailtalbeLoading"
        style="width: 100%; border: 1px solid #f0f0f0;"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <el-table-column label="用户pin">
          <template slot-scope="scope">
            <div v-if="scope.row.customerPin && scope.row.customerPin != ''">
              <span class="pinBody" v-if="!scope.row.isShow">
                <span class="pintitle">{{ scope.row.chaosPin }}</span>
                <el-button
                  class="pinBu"
                  @click="showPin(scope.$index)"
                  type="text"
                  >显示全部</el-button
                >
              </span>
              <span v-else>{{ scope.row.customerPin }}</span>
            </div>
            <!-- customerPin为空的话使用mixPin -->
            <div v-else>
              <span class="pinBody" v-if="!scope.row.isShow">
                <span class="pintitle">{{ scope.row.chaosPin }}</span>
                <el-button
                  class="pinBu"
                  @click="showPin(scope.$index)"
                  type="text"
                  >显示全部</el-button
                >
              </span>
              <span v-else>{{ scope.row.mixPin }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sendTime" label="发放时间"></el-table-column>
        <el-table-column label="发放状态">
          <template slot-scope="scope">
            <div
              v-if="!scope.row.sendStatus"
              style="display: flex; align-items: center"
            >
              <jd-status :status="3">发放失败</jd-status>
              <el-tooltip :content="scope.row.failReason" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
            <div v-else><jd-status :status="0">发放成功</jd-status></div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="pagination-box">
        <el-pagination
          background
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          style="text-align: right"
          :current-page="detailFrom.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="detailFrom.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="detailTotal"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createTask,
  queryTaskPage,
  uploadFile,
  queryRecordPage,
  stopTask,
  getTaskDetail,
} from "@/api/integralCenter/batchDistributionBenefits.js";
import {
  redPacketList,
  redEnvelopeDetail,
} from "@/api/integralCenter/prizeCenter.js";
import jdTips from "@/components/common/jdTips.vue";
import inputForm from "@/components/inputForm";
import jdStatus from "@/components/StatusTable/index.vue";
export default {
  name: "batchBeans",
  components: {
    inputForm,
    jdStatus,
    jdTips,
  },
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      redEnvelopeFromRules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        sendTime: [
          {
            required: true,
            message: "请选择发送时间",
            trigger: ["change", "blur"],
          },
        ],
        pinList: [{ required: true, message: "请输入pin", trigger: "blur" }],
        fileUrl: [
          {
            required: true,
            message: "请上传文件",
            trigger: ["change", "blur"],
          },
        ],
      },
      lookLoading: false,
      detailLoading: false,
      myformInfo: [
        {
          name: "任务昵称：",
          val: "taskName",
          placeholder: "请输入",
        },
        {
          name: "任务状态：",
          val: "status",
          defaultValue: "",

          selectArr: [
            { label: "全部", id: "" },
            { label: "待执行", id: 0 },
            { label: "执行中", id: 1 },
            { label: "执行结束", id: 2 },
            { label: "已终止", id: 3 },
          ],
        },
        {
          name: "创建时间：",
          val: "createTime",
          myDate: true,
          val: ["createTimeStart", "createTimeEnd"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          name: "任务类型：",
          val: "type",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "立即发送", id: 0 },
            { label: "定时发送", id: 1 },
          ],
        },
      ],
      couponDialogShow: false,
      selectCouponShow: false,
      detailDialogShow: false,
      form: {
        taskName: "",
        status: "",
        createTimeStart: "",
        createTimeEnd: "",
        sendType: 3,
        current: 1,
        size: 10,
        // createByMe: false,
        type: "",
      },
      pickerOptions2: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 1000 * 60 * 60 * 24;
        },
        // selectableRange:
        //   new Date().getHours() +
        //   ":" +
        //   (new Date().getMinutes() + 1) +
        //   ":00" +
        //   " - 23:59:59",
      },
      tableData: [],
      talbeLoading: false,
      numTotal: 0,
      redEnvelopeFrom: {
        taskName: "",
        type: 0,
        sendTime: "",
        selectCrowdType: 2,
        pinList: "",
        fileName: "",
        fileUrl: "",
        planId: "",
        planName: "",
        planToken: "",
      },
      selectList: [],
      jingdouItem: {
        sendTimes: "",
        budgetRemain: "",
      },
      redEnvelopeFromDisable: false,
      coupon: {
        couponDetail: "",
        couponId: "",
        couponName: "",
        takeBeginTime: "",
        takeEndTime: "",
        validity: "",
        validityType: "",
        addDays: "",
      },
      fileList: [],
      selectCouponForm: {
        name: "",
        couponIdOrPutKey: "",
        status: "",
        couponKind: "",
        beginTime: this.getDateStr(-30) + " 00:00:00",
        endTime: this.getDateStr(0) + " 23:59:59",
        current: 1,
        size: 10,
      },
      couponFromBtnLoading: false,
      coupontableData: [],
      coupontalbeLoading: false,
      couponTotal: 0,
      detailFrom: {
        customerPin: "",
        sendStatus: "",
        sendType: 3,
        size: 10,
        current: 1,
      },
      detailFromInfo: [
        {
          name: "用户pin：",
          val: "customerPin",
          placeholder: "请输入",
        },
        {
          name: "发放状态：",
          val: "sendStatus",
          defaultValue: "",
          selectArr: [
            { label: "全部", id: "" },
            { label: "发放成功", id: 0 },
            { label: "发放失败", id: 1 },
          ],
        },
      ],
      detailtableData: [],
      detailTotal: 0,
      detailtalbeLoading: false,
      total: 0,
      uploadStatus: -1,
      checkLoading: false,
      grant: {
        planName: "",
        quantityTotal: "",
        budgetRemain: "",
        successNum: "",
      },
      planLoading: false, // 计划加载中
    };
  },
  computed: {
    venderType() {
      return this.$store.getters.loginUserInfo.venderType;
    },
    sendTimeLimit() {
      return new Date(this.redEnvelopeFrom.sendTime).getTime() < Date.now();
    },
    currentShopTitle() {
      return this.$store.getters.loginUserInfo.sellerNick;
    },
    currentShopId() {
      return this.$store.getters.loginUserInfo.venderId;
    },
  },
  watch: {
    // "redEnvelopeFrom.sendTime"(selectTime) {
    //   const date = new Date(
    //     new Date(selectTime).setHours(0, 0, 0, 0)
    //   ).getTime();
    //   const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime();
    //   console.log(date, today, date == today);
    //   if (date == today) {
    //     // 当选择的日期就是当天的时候，这个时候就要限制时间应当小于此时此刻的时分秒
    //     this.pickerOptions2.selectableRange =
    //       new Date().getHours() +
    //       ":" +
    //       (new Date().getMinutes() + 1) +
    //       ":00" +
    //       " - 23:59:59";
    //   } else {
    //     // 当选择的日期小于当天的时候，这时需要把时分秒的限制放开，否则不能选择
    //     this.pickerOptions2.selectableRange = "00:00:00 - 23:59:59";
    //   }
    // },
  },
  mounted() {
    this.getBenefitList();
    this.getRedPacketList();
  },

  methods: {
    handleSizeChange(val) {
      this.form.size = val;
      this.getBenefitList();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.getBenefitList();
    },
    handleSizeChange2(val) {
      this.detailFrom.size = val;
      this.getRecordList();
    },
    handleCurrentChange2(val) {
      this.detailFrom.current = val;
      this.getRecordList();
    },
    showPin(index) {
      this.detailtableData[index].isShow = true;
    },
    changeShop() {
      this.getRedPacketList();
    },
    clearSendTime() {
      this.redEnvelopeFrom.sendTime = "";
    },
    // handleCreateByMe() {
    //   this.form.current = 1;
    //   this.getBenefitList();
    // },
    isToTenMin(sendTime, delay) {
      let time1 = new Date(sendTime).getTime();
      let time2 = Date.now();
      let time3 = time1 - time2;
      return (time3 * 1) / (1000 * 60) < delay * 1;
    },
    handleStop(row) {
      this.$confirm("您确定要终止任务吗? 终止后任务将不会执行", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        if (this.isToTenMin(row.sendTime, 10)) {
          return this.$message.error("距离发送时间不足10分钟，无法取消发送哦");
        }
        stopTask(row.id).then((res) => {
          if (res.code == "1") {
            this.$message.success(res.message);
            this.getBenefitList();
          } else {
            return this.$message.error(res.message);
          }
        });
      });
    },
    getBenefitList() {
      this.talbeLoading = true;
      queryTaskPage(this.form).then((res) => {
        this.tableData = res.data.records;
        this.talbeLoading = false;
        this.numTotal = +res.data.total;
      });
    },
    submitFormFun(data) {
      this.form = {
        ...this.form,
        taskName: data.taskName || "",
        status: data.status,
        createTimeStart: data.createTimeStart || "",
        createTimeEnd: data.createTimeEnd || "",
        type: data.type,
        sendType: 3,
        current: 1,
        size: 10,
      };
      this.getBenefitList();
    },
    clearTimeSendTime() {
      this.form.createTimeStart = "";
      this.form.createTimeEnd = "";
    },
    closeCouponDialog() {
      this.redEnvelopeFrom = {
        taskName: "",
        selectCrowdType: 2,
        type: 0,
        pinList: "",
        fileName: "",
        fileUrl: "",
        planId: "",
        planName: "",
        redPackAmount: "",
        planToken: "",
      };
      this.jingdouItem = {
        sendTimes: "",
        budgetRemain: "",
      };
      this.fileList = [];
      this.$refs.redEnvelopeFrom.clearValidate();
      this.uploadStatus = -1;
      this.couponDialogShow = false;
    },
    closeIntegralDialog() {},
    async batchCouponSure() {
      try {
        await this.$refs.redEnvelopeFrom.validate();

        if (!this.redEnvelopeFrom.taskName) {
          return this.$message.warning("请填写任务名称");
        }
        if (!this.redEnvelopeFrom.sendTime && this.redEnvelopeFrom.type == 1) {
          return this.$message.warning("请选择发送时间");
        }
        if (this.redEnvelopeFrom.type == 1 && this.sendTimeLimit) {
          return this.$message.warning(
            "发送时间不能设置为过去的时间，请重新设置"
          );
        }
        if (!this.redEnvelopeFrom.label) {
          return this.$message.warning("请选择红包计划");
        }
        let params = {
          taskName: this.redEnvelopeFrom.taskName,
          sendType: 3,
          type: this.redEnvelopeFrom.type,
          sendTime: this.redEnvelopeFrom.sendTime,
          selectCrowdType: this.redEnvelopeFrom.selectCrowdType,
          planId: this.redEnvelopeFrom.planId,
          planName: this.redEnvelopeFrom.planName,
          redPackAmount: this.redEnvelopeFrom.redPackAmount,
          planToken: this.redEnvelopeFrom.planToken,
          belongVenderId: this.currentShopId,
          belongShopTitle: this.currentShopTitle,
        };
        if (this.redEnvelopeFrom.selectCrowdType == 2) {
          params.pinList = this.redEnvelopeFrom.pinList.split("\n");
        } else if (this.redEnvelopeFrom.selectCrowdType == 3) {
          params.fileName = this.redEnvelopeFrom.fileName;
          params.fileUrl = this.redEnvelopeFrom.fileUrl;
        }
        this.couponFromBtnLoading = true;
        createTask(params)
          .then((res) => {
            if (res.code == 1) {
              this.closeCouponDialog();
              this.$message.success("添加成功");
              this.getBenefitList();
            } else {
              this.$message.warning(res.message);
            }
            this.couponFromBtnLoading = false;
          })
          .catch((err) => {
            this.couponFromBtnLoading = false;
          });
      } catch (error) {}
    },
    removeFile(file, fileList) {
      console.log(file, fileList);
      this.redEnvelopeFrom.fileUrl = "";
      this.redEnvelopeFrom.fileName = "";
      this.uploadStatus = -1;
      this.fileList = [];
    },
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > 50) {
        this.$message.warning("文件不得超过50M");
        return false;
      }
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    httpUpload({ file }) {
      console.log("file------------------", file);
      this.removeFile();
      let formData = new FormData();
      formData.append("file", file);
      this.uploadStatus = 0;
      console.log(formData);
      uploadFile(formData, 5).then((res) => {
        console.log("上传文件------------------", res);
        if (res.code == 1) {
          this.uploadStatus = 1;
          this.redEnvelopeFrom.fileUrl = res.data.fileUrl;
          this.redEnvelopeFrom.fileName = file.name;
          this.fileList = [{ name: file.name, url: res.data.fileUrl }];
        } else {
          this.uploadStatus = 2;
        }
      });
    },
    createTasks() {
      this.couponDialogShow = true;
      this.redEnvelopeFromDisable = false;
    },
    checkDetail(row) {
      this.couponDialogShow = true;
      this.lookLoading = true;
      getTaskDetail(row.id)
        .then((res) => {
          if (res.code == 1) {
            this.redEnvelopeFromDisable = true;
            this.lookLoading = false;
            this.redEnvelopeFrom.taskName = res.data.taskName;
            this.redEnvelopeFrom.type = res.data.type;
            this.redEnvelopeFrom.sendTime = res.data.sendTime;
            this.redEnvelopeFrom.selectCrowdType = res.data.selectCrowdType;
            this.redEnvelopeFrom.planName = res.data.planName;
            this.redEnvelopeFrom.redPackAmount = res.data.redPackAmount;
            this.redEnvelopeFrom.shopTitle = row.belongShopTitle;
            if (res.data.selectCrowdType == 3) {
              this.redEnvelopeFrom.fileName = res.data.fileName;
              this.redEnvelopeFrom.fileUrl = res.data.fileUrl;
            }
            if (res.data.selectCrowdType == 2) {
              this.redEnvelopeFrom.pinList = res.data.pinList.join("\n");
            }
          }
        })
        .catch(() => {
          this.lookLoading = false;
        });
    },
    checkGrant(row) {
      this.detailDialogShow = true;
      this.detailLoading = true;
      redEnvelopeDetail(row.planId)
        .then((res) => {
          this.detailLoading = false;
          this.grant.planName = res.data.planName;
          this.grant.quantityTotal = res.data.quantityTotal * 1;
          this.grant.redPackAmount = row.redPackAmount;
          this.grant.successNum = row.successNum;
          this.grant.shopTitle = row.belongShopTitle;
          this.detailFrom.id = row.id;
          this.getRecordList();
        })
        .catch(() => {
          this.detailLoading = false;
        });
    },
    getRecordList() {
      this.detailtalbeLoading = true;
      queryRecordPage(this.detailFrom).then((res) => {
        this.detailtalbeLoading = false;
        let detailtableData = res.data.records;
        detailtableData.forEach((item) => {
          item.isShow = false;
        });
        this.detailtableData = detailtableData;
        this.detailTotal = +res.data.total;
      });
    },
    distributionBeansSure(data) {
      this.detailFrom = {
        ...this.detailFrom,
        customerPin: data.customerPin || "",
        sendStatus: data.sendStatus,
        sendType: 3,
        size: 10,
        current: 1,
      };
      this.getRecordList();
    },
    async getRedPacketList() {
      this.redEnvelopeFrom.label = "";
      this.jingdouItem = {
        sendTimes: "",
        budgetRemain: "",
      };
      try {
        const res = await redPacketList({
          current: 1,
          size: 100,
          status: 2,
          venderId: this.currentShopId,
        });
        let selectArr = res.data.records.map((item) => {
          return {
            label: item.planName,
            value: item.id,
            quota: item.quota, // 红包计划剩余数量
            planToken: item.planToken,
            budgetRemain: item.budgetRemain,
          };
        });
        this.selectList = selectArr;
      } catch (error) {}
    },
    jumpJingduo() {
      let routeUrl = this.$router.resolve({
        path: "/integralCenter/prizeCenter/asset_management",
        query: {
          tabAct: 6,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    checkputn(e) {
      let filtered = e.target.value.replace(/^0|[^\d]/g, "");
      e.target.value = Number(filtered);
      if (e.target.value < 1) {
        e.target.value = "";
      }
    },
    planChange(val) {
      this.jingdouItem.budgetRemain = val.budgetRemain;
      this.jingdouItem.sendTimes = val.sendTimes;
      this.redEnvelopeFrom.redPackAmount = val.quota;
      this.redEnvelopeFrom.planId = val.value;
      this.redEnvelopeFrom.planName = val.label;
      this.redEnvelopeFrom.planToken = val.planToken;
    },
  },
};
</script>
<style lang="scss" scoped>
.fz14 {
  font-size: 14px;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}

.goodsselect_button {
  width: 145px;
  height: 32px;
  background: #f5f5f7;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  display: block;
  cursor: pointer;
  padding: 0 10px;
  border-radius: 2px;
  color: #333333;
  margin-left: 8px;
}

::v-deep .formitem_flex .el-form-item__content {
  display: flex;
  align-items: center;
}

.form_tip {
  width: 300px;
  background-color: #ebf3ff;
  padding: 8px 12px;
  font-size: 14px;
}

::v-deep .upload_item .el-form-item__content {
  position: relative;
  display: flex;
}

.detail_tip {
  background-color: #f4f4f5;
  padding: 12px;
  margin-bottom: 18px;
  overflow-x: auto;
  .detail-content {
    display: flex;
    // justify-content: space-between;
    // align-items: center;
    margin-bottom: 10px;
    flex-direction: row;
    flex-wrap: wrap;

    .content-item {
      min-width: 200px;
      margin-bottom: 20px;
      margin-right: 5px;
    }
  }
}

.select_goods {
  ::v-deep .el-form-item__content {
    margin-left: 0px !important;
    display: flex;
    align-items: center;
  }
}

.imgs {
  width: 14px;
  vertical-align: middle;
  margin-right: 6px;
  margin-top: -2px;
}

.form_tip {
  width: 300px;
  background-color: #f4f4f5;
  padding: 8px 12px;
  font-size: 12px;
}
.pinBody {
  .pintitle {
    display: block;
  }
  .pinBu {
    display: none;
  }
  &:hover {
    .pintitle {
      display: none;
    }
    .pinBu {
      display: block;
    }
  }
}
.ml8 {
  margin-left: 8px;
}
.btn-style {
  padding: 0 !important;
  width: auto;
}
</style>
